import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useMealMate } from "../context/MealMateContext";
import { Spin, notification } from "antd";
import { api, endpoints } from "../utils/axiosInstance";
import dayjs from "dayjs";

const ProtectedRoute = ({ children, allowedRoles = [], isPremium = false }) => {
  const {
    isAuthenticated,
    loading: authLoading,
    user,
    setShowLoginModal,
  } = useMealMate();

  const [subStatus, setSubStatus] = useState({
    checked: false,
    isActive: false,
  });
  const [subLoading, setSubLoading] = useState(false); // Khởi tạo false, chỉ set true khi cần check

  useEffect(() => {
    let isMounted = true;

    const checkSubscription = async () => {
      if (!isPremium || !isAuthenticated) return;

      setSubLoading(true); // Bắt đầu loading

      try {
        const res = await api.get(endpoints.orders.checkSubscription);
        const isExpired = res.expiryDate
          ? dayjs(res.expiryDate).isBefore(dayjs(), "day")
          : true;
        if (isMounted) {
          setSubStatus({
            checked: true,
            isActive: res.hasActiveSubscription && !isExpired,
          });
        }
      } catch (err) {
        if (isMounted) {
          setSubStatus({ checked: true, isActive: false });
        }
      } finally {
        if (isMounted) {
          setSubLoading(false); // Kết thúc loading
        }
      }
    };

    if (isPremium) {
      checkSubscription();
    } else {
      setSubStatus({ checked: true, isActive: true }); // Không cần check, mặc định cho phép
      setSubLoading(false);
    }

    return () => {
      isMounted = false; // Cleanup khi unmount
    };
  }, [isPremium, isAuthenticated]); // Thêm isAuthenticated để re-check khi auth thay đổi

  // Hiển thị loading nếu đang check auth hoặc sub
  if (authLoading || subLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    notification.warning({
      message: "Yêu cầu đăng nhập",
      description: "Vui lòng đăng nhập để truy cập trang này",
      duration: 3,
    });
    setShowLoginModal(true);
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    notification.error({
      message: "Không có quyền truy cập",
      description: "Bạn không có quyền truy cập trang này",
      duration: 3,
    });
    return <Navigate to="/" replace />;
  }

  // Chỉ kiểm tra Premium khi subStatus đã được kiểm tra (checked: true)
  if (isPremium && subStatus.checked && !subStatus.isActive) {
    notification.warning({
      message: "Tính năng Premium",
      description:
        "Tính năng này chỉ dành cho thành viên Premium. Vui lòng nâng cấp gói dịch vụ để sử dụng!",
      duration: 4,
      placement: "topRight",
    });
    return <Navigate to="/account/subscription" replace />;
  }

  return children;
};

export default ProtectedRoute;
